import type { LangToggleContent } from "../types";

export const langToggle: LangToggleContent = {
  ariaLabel: "Sprog",
  targetLabel: "EN",
  targetName: "Engelsk",
};
